export default __webpack_public_path__ + "static/media/kitten cam.51b4278f.jpg";